import { Link } from "react-router-dom";
import BoxIcon from "../../components/ui/box-icon/box-icon";
import Button from "../../components/ui/button/button";
import CardDefault from "../../components/ui/cards/card-default/card-default";
import IconDescription from "../../components/ui/icon-description/icon-description";
import { PATH } from "../../constants/navigation";
import { useBreakpoint } from "../../hooks/useBreakpoint";

import "./notFound.scss";

const NotFound: React.FC = () => {
  const device = useBreakpoint();
  const isMobile = device === "mobile" || device === "tablet";
  return (
    <div className="not-found">
      <div className="not-found__top">
        <h1 className="not-found__title">404</h1>
        <div className="not-found__icons">
          <BoxIcon icon={"helmet"} size={"medium"} type={"primary-rounded"} />
          <BoxIcon icon={"alert"} size={"big"} type={"tertiary-rounded"} />
          <BoxIcon
            icon={"screwdriver"}
            size={"medium"}
            type={"primary-rounded"}
          />
        </div>
      </div>
      <div className="not-found__central">
        <h2 className="not-found__description-title">
          Oops! Cantiere in Corso
        </h2>
        <p className="not-found__description-text">
          Sembra che la pagina che stai cercando sia ancora in costruzione o sia
          stata spostata. I nostri ingegneri stanno lavorando sodo per
          sistemarla!
        </p>
        <div className="not-found__button">
          <Button
            text={"Torna alla Homepage"}
            type={"primary"}
            to={PATH.home}
            iconName="house"
            fullWidth={!!isMobile}
          />
        </div>
      </div>
      <div className="not-found__bottom">
        <Link to={PATH.poles} className="not-found__link">
          <CardDefault type={"dark-grey"} width="full-width" clickable>
            <IconDescription
              icon={"hole"}
              title={"Pali Rotoinfissi"}
              text={"Scopri i nostri servizi"}
              type={"primary"}
              size={"medium"}
              color="dark"
              direction="vertical"
            />
          </CardDefault>
        </Link>
        <Link to={PATH.consultancy} className="not-found__link">
          <CardDefault type={"dark-grey"} width="full-width" clickable>
            <IconDescription
              icon={"clipboard"}
              title={"Consulenza"}
              text={"Supporto tecnico"}
              type={"primary"}
              size={"medium"}
              color="dark"
              direction="vertical"
            />
          </CardDefault>
        </Link>
        <Link to={PATH.contacts} className="not-found__link">
          <CardDefault type={"dark-grey"} width="full-width" clickable>
            <IconDescription
              icon={"phone"}
              title={"Contatti"}
              text={"Parla con noi"}
              type={"primary"}
              size={"medium"}
              color="dark"
              direction="vertical"
            />
          </CardDefault>
        </Link>
        <Link to={PATH.about} className="not-found__link">
          <CardDefault type={"dark-grey"} width="full-width" clickable>
            <IconDescription
              icon={"user"}
              title={"Chi siamo"}
              text={"La nostra storia"}
              type={"primary"}
              size={"medium"}
              color="dark"
              direction="vertical"
            />
          </CardDefault>
        </Link>
      </div>
    </div>
  );
};
export default NotFound;
